var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('st-filters-pagination',{attrs:{"stateModule":"applications/list","filters":_vm.filters,"total":_vm.total,"header":_vm.header,"clearButtonInPrimaryFilters":true},on:{"change":_vm.doFilter}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }